import styled from 'styled-components'
import { tokens } from 'app-v2/design-systems/theme'
import { colors } from 'app-v2/design-systems/theme/colors'
import { H6, H7, H9 } from 'app-v2/design-systems/typography/titles'
import { SmallCaptionText } from 'app-v2/design-systems/typography/text'
import { SPACING } from 'app-v2/design-tokens'

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 177px;
    height: 280px;
    position: relative;
`

export const StyledCouponContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 248px;
    width: 100%;
    background: ${props =>
        props.fromEcommerce ? colors.mayoEggWhite : colors.lightMayo};
    border-radius: ${tokens.borderRadius}px;
    opacity: ${props => props.opacity};
`

export const StyledCouponTopContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 120px;
    width: 100%;
    border-top-left-radius: ${tokens.borderRadius}px;
    border-top-right-radius: ${tokens.borderRadius}px;
    background: ${props => props.topBackgroundColor};
    background-image: ${props => `url(${props.backgroundImageUrl})`};

    ${({ shouldDisplayGradient }) =>
        shouldDisplayGradient &&
        'background: linear-gradient(66.22deg, #8478B6 -7.01%, #6A5CA5 45.99%, #4A368C 98.98%);'}}
`

export const StyledBlazonContainer = styled.div`
    margin-top: -100px;
    margin-left: 150px;
    height: 18px;
    width: 16px;
`

export const StyledEnableMessage = styled(H7)`
    text-align: center;
    width: 100%;
    height: 100%;
    color: ${props => props.color};
    position: absolute;
    padding-top: ${SPACING.XXL};
`

export const StyledBlazon = styled.img`
    display: flex;
    margin-top: -22px;
    margin-left: 2px;
    width: 80%;
    height: 80%;
    aspect-ratio: ${184 / 208};
`

export const StyledImageContainer = styled.div`
    margin-left: 40px;
    margin-top: 10px;
    height: 100px;
`

export const StyledImage = styled.img`
    height: 100%;
    aspect-ratio: 1;
`

export const StyledCouponSeparatorContainer = styled.div`
    height: 8px;
    margin-top: -88px;
`

export const StyledCouponBottomContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 94px;
    width: 100%;
    gap: 3px;
`

export const StyledCouponTitle = styled(H9)`
    display: flex;
    align-self: center;
    text-align: center;
`

export const StyledCouponSubInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;
`

export const StyledCouponExpirationDate = styled(SmallCaptionText)`
    text-align: center;
    align-self: center;
    padding-left: ${tokens.smallCaptionHorizontalPadding}px;
    padding-right: ${tokens.smallCaptionHorizontalPadding}px;
`

export const StyledCouponLocation = styled(SmallCaptionText)`
    text-align: center;
    align-self: center;
    padding-left: ${tokens.smallCaptionHorizontalPadding}px;
    padding-right: ${tokens.smallCaptionHorizontalPadding}px;
`

export const StyledButtonContainer = styled.div`
    margin-top: -20px;
    align-self: center;
`
